import { motion } from "framer-motion";
import { CalendarCheck, Phone } from "lucide-react";
import { useBooking } from "@/components/site/BookingContext";
import { CONTACT } from "@/data/site";

export const PrenotaCTA = () => {
  const { openBooking } = useBooking();
  return (
    <section data-testid="prenota-cta" className="relative overflow-hidden bg-brand-red text-white">
      {/* animated glow */}
      <motion.div
        aria-hidden
        className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white/10 blur-3xl"
        animate={{ scale: [1, 1.2, 1], opacity: [0.5, 0.8, 0.5] }}
        transition={{ duration: 6, repeat: Infinity }}
      />
      <motion.div
        aria-hidden
        className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-brand-black/30 blur-3xl"
        animate={{ scale: [1.2, 1, 1.2] }}
        transition={{ duration: 7, repeat: Infinity }}
      />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24 flex flex-col lg:flex-row items-center justify-between gap-10 text-center lg:text-left">
        <div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.3em] text-white/80 mb-5"
          >
            <span className="w-2 h-2 rounded-full bg-white animate-pulse" /> La tua formazione inizia qui
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-heading font-black uppercase tracking-tighter leading-[0.9] text-4xl md:text-6xl lg:text-7xl"
          >
            Scegli il corso. Al resto pensiamo noi.
          </motion.h2>
          <p className="mt-5 text-white/85 max-w-xl mx-auto lg:mx-0">
            Seleziona il percorso che ti interessa e invia la tua richiesta. Riceverai via email tutte le informazioni su disponibilità, costi e modalità di iscrizione.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row lg:flex-col gap-4 shrink-0 w-full sm:w-auto">
          <motion.button
            onClick={() => openBooking()}
            data-testid="prenota-cta-button"
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            animate={{ boxShadow: ["0 0 0 0 rgba(255,255,255,0.5)", "0 0 0 16px rgba(255,255,255,0)"] }}
            transition={{ boxShadow: { duration: 1.8, repeat: Infinity } }}
            className="inline-flex items-center justify-center gap-2 bg-white text-brand-black font-black uppercase tracking-widest text-base px-10 py-5 hover:bg-brand-black hover:text-white transition-colors"
          >
            <CalendarCheck size={20} /> Prenota ora
          </motion.button>
          <a
            href={`tel:${CONTACT.phone}`}
            data-testid="prenota-cta-call"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white font-bold uppercase tracking-widest text-sm px-10 py-4 hover:bg-white hover:text-brand-red transition-colors"
          >
            <Phone size={18} /> {CONTACT.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
};
